import { Component, ViewEncapsulation, Injector } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { ModalService } from '../../../services/modal.service';
import { ProfileService } from '../../../services/profile.service';

@Component({
  selector: 'app-terms-modal',
  templateUrl: './confirm-decline.component.html',
  styleUrls: ['./confirm-decline.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class ConfirmDeclineComponent {
  modalService: any;
  public content: string;
  public withAcceptance: boolean;

  constructor(
    private activeModal: NgbActiveModal,
    private injector: Injector,
    private profileService: ProfileService
  ) {
    this.modalService = injector.get(ModalService);
  }

  close(result: boolean) {
    this.activeModal.close(result);
  }

  cancel() {
    this.close(false);
  }

  logout() {
    this.profileService.logout();
    this.close(true);
  }
}
